import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { PaginatedResponse } from '@/modules/common/types/pagination-types';
import { axiosInstance } from '@/utils/axios';

import { mapTimeOffTypeChangesFromResponse } from '../mappers/time-off-changes.mapper';
import { GetTimeOffTypeChangesRequest } from '../types/dto/request/time-off-type-changes-request';
import { TimeOffTypeChangeResponse } from '../types/dto/response/time-off-type-change-response';
import { TimeOffTypeChangeLogEntry } from '../types/time-off-changes';

/**
 * Searches the scheduled changes for a time-off type.
 * Endpoint: POST /api/time-off/settings/types/{typeId}/changes/search
 */
export const getTimeOffTypeChanges = async ({
  typeId,
  pagination,
  fromDate,
  toDate,
  changedByUserIds,
}: GetTimeOffTypeChangesRequest): Promise<PaginatedResponse<TimeOffTypeChangeLogEntry>> => {
  const endpoint = `/api/time-off/settings/types/${typeId}/changes/search`;

  const apiData = await withApiErrorHandler(
    endpoint,
    ApiErrorCode.TIME_OFF_TYPE_CHANGES_LOAD_FAILED,
    () =>
      axiosInstance.post<
        ApiResponse<{
          items: TimeOffTypeChangeResponse[];
          pagination: { total: number; cursor: number | null };
        }>
      >(endpoint, { pagination, fromDate, toDate, changedByUserIds })
  );

  return new PaginatedResponse({
    items: mapTimeOffTypeChangesFromResponse(apiData.items),
    pagination: apiData.pagination,
  });
};

interface DeleteTimeOffTypeChangeParams {
  typeId: number;
  changeId: number;
}

export const deleteTimeOffTypeChange = async ({
  typeId,
  changeId,
}: DeleteTimeOffTypeChangeParams): Promise<unknown> => {
  const endpoint = `/api/time-off/settings/types/${typeId}/changes/${changeId}`;

  const apiData = await withApiErrorHandler(
    endpoint,
    ApiErrorCode.TIME_OFF_TYPE_CHANGES_LOAD_FAILED,
    () => axiosInstance.delete<ApiResponse<unknown>>(endpoint)
  );

  return apiData;
};
